var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCryptodataFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.948,
    height: 18.5,
    viewBox: "0 0 9.948 18.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cryptodata-facebook",
    transform: "translate(-121.387 0.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3686",
    "data-name": "Group 3686",
    transform: "translate(121.637)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17756",
    "data-name": "Path 17756",
    d: "M128.807,3.912h1.64a.638.638,0,0,0,.637-.637V.639A.638.638,0,0,0,130.447,0h-2.252l-.112,0a4.7,4.7,0,0,0-3.075,1.162A3.332,3.332,0,0,0,123.9,4.1V5.813h-1.63a.638.638,0,0,0-.637.637V9.285a.638.638,0,0,0,.637.637h1.536v7.441a.638.638,0,0,0,.637.637h3.212a.638.638,0,0,0,.637-.637v-7.4h1.819a.637.637,0,0,0,.633-.564l.331-2.871a.637.637,0,0,0-.633-.71H128.3V4.371C128.3,4.074,128.378,3.912,128.807,3.912Zm-.868,2.618h2.419l-.312,2.712h-2.107a.359.359,0,0,0-.359.359v7.683h-3.053V9.563a.359.359,0,0,0-.359-.359h-1.815V6.53h1.909a.359.359,0,0,0,.359-.359v-2.1a.36.36,0,0,0-.005-.061,2.6,2.6,0,0,1,.877-2.315,3.962,3.962,0,0,1,2.59-.973l.086,0h2.2V3.2h-1.56a1.1,1.1,0,0,0-1.227,1.176v1.8A.359.359,0,0,0,127.939,6.53Z",
    transform: "translate(-121.637)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCryptodataFacebook);
export default __webpack_public_path__ + "static/media/cryptodata-facebook.f1caeeef675323c8499bf4269009eb3a.svg";
export { ForwardRef as ReactComponent };